import React from 'react';
import { flushSync } from 'react-dom';
import {
  Box,
  Flex,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Divider,
  VStack,
  HStack,
  CircularProgress,
  CircularProgressLabel,
  Input,
  Grid,
  IconButton,
  Spinner,
  Image,
  useBreakpointValue,
  Progress,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from '@chakra-ui/react';
import { keyframes } from '@chakra-ui/system';
import { RepeatIcon } from '@chakra-ui/icons';
import moment from 'moment-timezone';
import axiosInstance from 'axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import mqtt from 'mqtt';
import { useEffect, useState, useRef } from 'react';
import { ReactComponent as BorewellIconPumpOn } from '../../../assets/icons/Borewell_Icon_Pump_On.svg';
import { ReactComponent as BorewellIconPumpOff } from '../../../assets/icons/Borewell_Icon_Pump_Off.svg';
import { ReactComponent as WaterLimitIcon } from '../../../assets/icons/Water Limit Icon.svg';
import { ReactComponent as TankLevelIcon } from '../../../assets/icons/Tank Icon.svg';
// import BorewellImage from '../../../assets/icons/valve.png';
import BorewellImage from '../../../assets/icons/apartment.jpg';
import { ReactComponent as DisconnectedIcon } from '../../../assets/icons/Disconnected device.svg';
import { ReactComponent as ConnectedIcon } from '../../../assets/icons/Connected device.svg';
import { ReactComponent as RemoteButtonOn } from '../../../assets/icons/Remote operation.svg';
import { ReactComponent as RemoteButtonOff } from '../../../assets/icons/Remote_operation_off.svg';
import PumpProcessing from '../../../assets/icons/mqtt_pump_processing.gif';
import OnIcon from '../../../assets/icons/valve_on.png';
import OffIcon from '../../../assets/icons/valve_close.png';
import Overview from '../profile';
import { MdNewReleases } from 'react-icons/md';
import { setISODay } from 'date-fns';

export default function Dashboard() {
  const gridCols = useBreakpointValue({ base: 1, md: 2, lg: 3 });
  const [overViewData, setOverViewData] = useState([]);
  const [tankOverViewData, setTankOverViewData] = useState([]);
  const [isTankModalOpen, setisTankModalOpen] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [limitPerDay, setLimitPerDay] = useState();
  const [limitPerYear, setlimitPerYear] = useState();
  const [WaterTankLevel, setWaterTankLevel] = useState(0);
  const [plantDailyCons, setPlantDailyCons] = useState(0);
  const [plantYearlyCons, setPlantYearlyCons] = useState(0);
  const [pendingPacket, setPendingPacket] = useState(null);
  const [pendingTopic, setPendingTopic] = useState(null);
  const [isProcessing, setProcessing] = useState(false);

  const dailyProgressValue = (plantDailyCons / limitPerDay) * 100;
  const yearlyProgressValue = (plantYearlyCons / limitPerYear) * 100;

  const selectedCompany = useRef('');
  const ACK_TIMEOUT = 15;
  const publishingRef = useRef(false);
  const ackReceivedRef = useRef(false);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const clientRef = useRef(null);
  const cancelRef = useRef();
  const pendingPIDRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedPID, setSelectedPID] = useState('');

  const toast = useToast();
  const Token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');

  // Local Broker
  // const brokerUrl = 'ws://localhost:8082';
  // const username = '';
  // const password = '';

  // Staging Broker
  const brokerUrl = 'wss://atbcmqtt.aquasense.tech:9001';
  const username = 'admin';
  const password = 'fVAYl6k2Kd9Z';

  // Production Broker
  // const brokerUrl = 'wss://atbc.aquasense.tech:9001';
  // const username = 'atbcmqtt';
  // const password = 'atbc@mqtt1911';

  // Define the blinking keyframes
  const blinkAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

  const blinkingOverlayProps = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    borderRadius: 'full',
    // Note: To match the border, you might need to adjust 'border' size, or use
    // the refined centering/sizing from the previous answer (e.g., width="90px", margin="-3px")
    // For simplicity, I'll stick to the current 100% with border-box, but keep
    // the need for fine-tuning in mind if the alignment is off.
    border: '8px solid white',
    animation: `${blinkAnimation} 1s infinite alternate`,
    boxSizing: 'border-box',
    pointerEvents: 'none',
    zIndex: '100',
  };

  const formatForDateTimeLocal = (isoString) => {
    if (!isoString) return '-';
    return moment(isoString).format('DD/MM/YY HH:mma');
  };

  const generateMid = () =>
    Math.floor(100000000 + Math.random() * 900000000).toString();

  const confirmAndSend = (packet, topic) => {
    // store packet/topic temporarily until user confirms
    setPendingPacket(packet);
    setPendingTopic(topic);
    onOpen();
  };

  const toggleIsProcessing = () => {
    setProcessing(true);
    setTimeout(() => {
      setProcessing(false);
    }, 16000);
  };

  const tanksOverview = () => {
    const tankData = Object.values(
      overViewData.reduce((acc, device) => {
        const tank = device.tankMetaData;
        if (!tank) return acc;

        const tankId = tank._id;

        // Create tank entry if not exists
        if (!acc[tankId]) {
          acc[tankId] = {
            _id: tank._id,
            name: tank.name,
            capacity: tank.capacity,
            connected_to: [],
            tank_water_level: device?.tank_sensor?.water_level ?? null,
            tank_water_temperature:
              device?.tank_sensor?.water_temperature ?? null,
          };
        }

        // Push productId (avoid duplicates)
        if (!acc[tankId].connected_to.includes(device.productId)) {
          acc[tankId].connected_to.push(device.productId);
        }

        return acc;
      }, {}),
    );
    console.log(tankData);
    setTankOverViewData(tankData);
  };

  const handlePumpToggle = (pump_status, productId) => {
    pendingPIDRef.current = productId;
    let cmdPacketPumpOperation = {};
    let pump_control = '';
    if (pump_status === 'on') {
      pump_control = 'off';
    } else {
      pump_control = 'on';
    }

    const timestamp = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
    const mid = generateMid();

    cmdPacketPumpOperation.pid = productId;
    cmdPacketPumpOperation.mid = mid;
    cmdPacketPumpOperation.timestamp = timestamp;
    cmdPacketPumpOperation.pump_control = pump_control;

    const jsonParsed = JSON.stringify(cmdPacketPumpOperation);
    confirmAndSend(jsonParsed, 'ATBC/C2D');
  };

  const handleRemoteToggle = (remote_operations, productId) => {
    pendingPIDRef.current = productId;
    let cmdPacketRemoteOperation = {};
    let remote_operation_status = '';
    if (remote_operations === 'on') {
      remote_operation_status = 'off';
    } else {
      remote_operation_status = 'on';
    }

    const timestamp = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
    const mid = generateMid();

    cmdPacketRemoteOperation.pid = productId;
    cmdPacketRemoteOperation.mid = mid;
    cmdPacketRemoteOperation.timestamp = timestamp;
    cmdPacketRemoteOperation.remote_operations = remote_operation_status;

    const jsonParsed = JSON.stringify(cmdPacketRemoteOperation);
    confirmAndSend(jsonParsed, 'ATBC/C2D');
  };

  // const handleConfirm = () => {
  //   onClose();

  //   const packet = pendingPacket;
  //   const topic = pendingTopic;

  //   if ("pump_control" in JSON.parse(packet)) {
  //      toggleIsProcessing();
  //    }

  //   if (publishingRef.current) {
  //     toast({
  //       title: 'Please wait for the previous operation to complete',
  //       status: 'warning',
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //     return;
  //   }

  //   if (!clientRef.current) {
  //     console.error('MQTT client is not connected');
  //     return;
  //   }

  //   publishingRef.current = true;

  //   clientRef.current.publish(topic, packet, { qos: 2 }, (err) => {
  //     if (err) {
  //       publishingRef.current = false;
  //       toast({
  //         title: 'Failed to publish packet',
  //         status: 'error',
  //         duration: 3000,
  //       });
  //     } else {
  //       toast({
  //         title: 'Packet sent successfully!',
  //         status: 'success',
  //         duration: 2000,
  //       });

  //       let countdown = ACK_TIMEOUT;
  //       toast({
  //         id: 'ack-countdown',
  //         title: `Waiting for device acknowledgment... ${countdown}s`,
  //         status: 'info',
  //         duration: null,
  //         isClosable: false,
  //       });

  //       intervalRef.current = setInterval(() => {
  //         countdown -= 1;
  //         if (countdown > 0) {
  //           toast.update('ack-countdown', {
  //             title: `Waiting for device acknowledgment... ${countdown}s`,
  //             status: 'info',
  //             duration: null,
  //           });
  //         }
  //       }, 1000);

  //       timeoutRef.current = setTimeout(() => {
  //         if (!ackReceivedRef.current) {
  //           clearInterval(intervalRef.current);
  //           toast.close('ack-countdown');
  //           publishingRef.current = false;
  //           toast({
  //             title: 'Device did not respond, rolling back to previous state',
  //             status: 'error',
  //             duration: 4000,
  //             isClosable: true,
  //           });
  //         }
  //       }, ACK_TIMEOUT * 1000);
  //     }
  //   });
  // };

  const handleConfirm = () => {
    onClose();

    const packet = pendingPacket;
    const topic = pendingTopic;

    // If pump control packet → show loader
    if ('pump_control' in JSON.parse(packet)) {
      toggleIsProcessing();
    }

    // Prevent parallel publishes
    if (publishingRef.current) {
      toast({
        title: 'Please wait for the previous operation to complete',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!clientRef.current) {
      console.error('MQTT client is not connected');
      return;
    }

    publishingRef.current = true;

    clientRef.current.publish(topic, packet, { qos: 2 }, (err) => {
      if (err) {
        publishingRef.current = false;
        toast({
          title: 'Failed to publish packet',
          status: 'error',
          duration: 3000,
        });
        return;
      }

      // Success message
      toast({
        title: 'Packet sent successfully!',
        status: 'success',
        duration: 2000,
      });

      // ---- CLEANUP ANY PAST OPERATIONS ----
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      toast.close('ack-countdown'); // remove stuck toast if any
      ackReceivedRef.current = false;

      // ---- START ACK COUNTDOWN ----
      let countdown = ACK_TIMEOUT;

      toast({
        id: 'ack-countdown',
        title: `Waiting for device acknowledgment... ${countdown}s`,
        status: 'info',
        duration: null,
        isClosable: false,
      });

      intervalRef.current = setInterval(() => {
        countdown -= 1;

        if (countdown <= 0) return;

        try {
          toast.update('ack-countdown', {
            title: `Waiting for device acknowledgment... ${countdown}s`,
            status: 'info',
            duration: null,
            isClosable: false,
          });
        } catch (err) {
          console.warn('Toast update failed, clearing countdown:', err);
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }, 1000);

      // ---- TIMEOUT HANDLER ----
      timeoutRef.current = setTimeout(() => {
        if (!ackReceivedRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;

          toast.close('ack-countdown');

          publishingRef.current = false;

          toast({
            title: 'Device did not respond, rolling back to previous state',
            status: 'error',
            duration: 4000,
            isClosable: true,
          });
        }
      }, ACK_TIMEOUT * 1000);
    });
  };

  const handleCancel = () => {
    onClose();
    toast({
      title: 'Command cancelled',
      status: 'info',
      duration: 2000,
    });
  };

  const plantOverviewData = (data) => {
    let plantDailyConsumption = 0;
    let plantYearlyConsumption = 0;
    let plantTankLevel = 0;

    for (let item of data) {
      const dailyConsumption =
        item.dailyConsumption !== '-' &&
        item.dailyConsumption !== null &&
        item.dailyConsumption !== ''
          ? parseFloat(item.dailyConsumption)
          : 0;
      const yearlyConsumption =
        item.yearlyConsumption !== '-' &&
        item.yearlyConsumption !== null &&
        item.yearlyConsumption !== ''
          ? parseFloat(item.yearlyConsumption)
          : 0;
      const water_level =
        item.tank_sensor.water_level !== '-' &&
        item.tank_sensor.water_level !== null
          ? parseFloat(item.tank_sensor.water_level)
          : 0;
      plantDailyConsumption += dailyConsumption;
      plantYearlyConsumption += yearlyConsumption;
      plantTankLevel += water_level;
    }

    setWaterTankLevel(plantTankLevel / data.length);
    setPlantDailyCons(plantDailyConsumption.toFixed(2));
    setPlantYearlyCons(plantYearlyConsumption.toFixed(2));
  };

  const fetchOverviewData = async () => {
    try {
      let response;
      if (['companyUser', 'user'].includes(userRole)) {
        response = await axiosInstance.get(
          `${baseUrl}/device-readings/fetchOverviewData`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      } else if (userRole === 'admin') {
        response = await axiosInstance.get(
          `${baseUrl}/device-readings/fetchOverviewData?companyId=${selectedCompany.current}`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      }
      if (response) {
        const data = response?.data?.data?.data;
        plantOverviewData(data);
        setOverViewData(data || []);
      }
    } catch (error) {
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/company/list`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      if (response) {
        const data = response?.data?.data?.data;
        setCompanyData(data);
        if (!data || data.length <= 0) {
          toast({
            title: 'No companies found',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchPermissibleLimits = async () => {
    try {
      let response;
      if (['companyUser', 'user'].includes(userRole)) {
        response = await axiosInstance.get(
          `${baseUrl}/company/getPermissibleLimits`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      } else if (userRole === 'admin') {
        response = await axiosInstance.get(
          `${baseUrl}/company/getPermissibleLimits?companyId=${selectedCompany.current}`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      }
      if (response) {
        const data = response?.data?.data;
        setLimitPerDay(data[0].limitPerDay);
        setlimitPerYear(data[0].limitPerYear);
      }
    } catch (error) {
      toast({
        title: error?.response?.data?.data
          ? error?.response?.data?.data
          : error?.response?.data?.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const getQueryString = (params) => {
    return Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== '')
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
  };

  const updatePumpStatus = (productId, newStatus) => {
    setOverViewData((prevData) =>
      prevData.map((item) =>
        item.productId === productId
          ? {
              ...item,
              system: {
                ...item.system,
                pump_status: newStatus,
              },
            }
          : item,
      ),
    );
  };

  const updateRemoteStatus = (productId, newStatus) => {
    setOverViewData((prevData) =>
      prevData.map((item) =>
        item.productId === productId
          ? {
              ...item,
              system: {
                ...item.system,
                remote_operations: newStatus,
              },
            }
          : item,
      ),
    );
  };

  const handleRefresh = async () => {
    setLoading(true);

    try {
      await fetchOverviewData();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      toast({
        title: 'Abstraction updated successfully',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (['companyUser', 'user'].includes(userRole)) {
      fetchOverviewData();
    }
  }, []);

  useEffect(() => {
    if (userRole === 'admin') {
      fetchCompanies();
    }
  }, []);

  useEffect(() => {
    if (['companyUser', 'user'].includes(userRole)) {
      fetchPermissibleLimits();
    }
  }, []);

  useEffect(() => {
    const client = mqtt.connect(brokerUrl, {
      username: username,
      password: password,
      clean: true, // start a clean session
      reconnectPeriod: 3000,
      connectTimeout: 4000,
    });
    clientRef.current = client;

    const onAck = (msgTopic, message) => {
      if (msgTopic === 'ATBC/D2C') {
        const recPacket = JSON.parse(message.toString());

        // Remote operations
        if (
          'remote_operations' in recPacket &&
          pendingPIDRef.current === recPacket.pid
        ) {
          if (recPacket['result'] === 'pass') {
            toast({
              title: 'Device acknowledged remote operation command',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            updateRemoteStatus(recPacket.pid, recPacket.remote_operations);
          } else {
            toast({
              title: 'Command failed remote operation',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            toast({
              title: 'Getting back to last state',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
        }

        // Pump Control
        else if (
          'pump_control' in recPacket &&
          pendingPIDRef.current === recPacket?.pid
        ) {
          if (recPacket['result'] === 'pass') {
            setProcessing(false);
            toast({
              title: 'Device acknowledged pump control command',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            updatePumpStatus(recPacket.pid, recPacket.pump_control);
          } else {
            setProcessing(false);
            toast({
              title: 'Command failed pump control',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            toast({
              title: 'Getting back to last state',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
        }
        ackReceivedRef.current = true;
        publishingRef.current = false;
        clearInterval(intervalRef.current);
        clearTimeout(timeoutRef.current);
        toast.close('ack-countdown');
      }
    };

    // const onDeviceStatus = (msgTopic, message) => {
    //   const decodedPacket = message.toString().split(',');
    //   console.log(decodedPacket, "message received in main function")
    //   const productId = decodedPacket[0];
    //   const currStatus = decodedPacket[1];
    //   flushSync(() => {
    //     setOverViewData((prevData) =>
    //       prevData.map((item) =>
    //         item.productId === productId
    //           ? {
    //               ...item,
    //               status: currStatus,
    //             }
    //           : item,
    //       ),
    //     );
    //   });
    // };

    const onDeviceStatus = (msgTopic, message) => {
      const [productId, currStatus] = message.toString().split(',');
      console.log(productId, currStatus);

      setOverViewData((prev) =>
        prev.map((item) =>
          item.productId === productId
            ? { ...item, status: currStatus, lastUpdated: Date.now() }
            : item,
        ),
      );
    };

    const onData = (msgTopic, message) => {
      const newReading = {};
      const recPacket = JSON.parse(message.toString());

      const flowRate = recPacket.flowmeter_sensor.flowrate;
      const totalizer = recPacket.flowmeter_sensor.totalizer;
      const tankLevel = recPacket.tank_sensor.water_level;
      const tankTemp = recPacket.tank_sensor.water_temperature;
      const batteryLevel = recPacket.battery_level;
      const datetime = moment(
        recPacket.timestamp,
        'YYYY-MM-DD HH:mm:ss',
      ).toISOString();

      newReading.batterLevel = batteryLevel;
      newReading.pid = recPacket.pid;
      newReading.system = recPacket.system;
      newReading.flowmeter_sensor = {
        flowrate: flowRate,
        totalizer: totalizer,
      };

      newReading.tank_sensor = {
        water_temperature: tankTemp,
        water_level: tankLevel,
      };

      setOverViewData((prevData) =>
        prevData.map((item) =>
          item.productId === recPacket.pid
            ? {
                ...item,
                updatedAt: datetime,
                system: newReading.system,
                flowmeter_sensor: newReading.flowmeter_sensor,
                tank_sensor: newReading.tank_sensor,
              }
            : item,
        ),
      );
    };

    client.on('connect', () => {
      console.log('Connected to broker');
      client.subscribe(['ATBC/D2C', 'ATBC/STATE', 'ATBC/STATUS/+'], (err) => {
        if (err) console.error('Subscription failed:', err);
      });

      client.on('message', (topic, message) => {
        const t = topic.toString().trim(); // ensure it's a clean string

        if (t === 'ATBC/D2C') {
          onAck(t, message);
        } else if (t === 'ATBC/STATE') {
          onData(t, message);
        } else if (t.startsWith('ATBC/STATUS/')) {
          console.log('Subscribed to ATBC/STATUS', t, message.toString());
          setTimeout(() => {
            onDeviceStatus(t, message);
          }, 4000);
        }
      });
    });

    return () => {
      client.off('message', onAck);
      client.unsubscribe('ATBC/D2C');
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
      client.end(true);
    };
  }, []);

  return (
    <>
      <Modal
        isOpen={isTankModalOpen}
        onClose={() => setisTankModalOpen(false)}
        size="2xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius="xl">
          <ModalHeader fontSize="xl" fontWeight="bold">
            Tanks Overview
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            <Table variant="striped">
              <Thead>
                <Tr>
                  <Th textAlign="center" color="rgba(0, 106, 184, 1)">
                    Tanks
                  </Th>
                  <Th textAlign="center" color="rgba(0, 106, 184, 1)">
                    Tank Name
                  </Th>
                  <Th textAlign="center" color="rgba(0, 106, 184, 1)">
                    Tank Capacity
                  </Th>
                  <Th textAlign="center" color="rgba(0, 106, 184, 1)">
                    Connected To
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {tankOverViewData?.map((tank, index) => (
                  <Tr key={index}>
                    {/* Tank Icon */}
                    <Td textAlign="center">
                      <Flex justify="center">
                        <Box position="relative" w="80px" h="80px">
                          <TankLevelIcon width="80px" height="80px" />
                          <Text
                            position="absolute"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            fontSize="lg"
                            fontWeight="bold"
                            color="rgba(17, 128, 211, 1)"
                          >
                            {parseFloat(tank.tank_water_level).toFixed(0)}%
                          </Text>
                        </Box>
                      </Flex>
                    </Td>

                    {/* Tank Name */}
                    <Td textAlign="center">
                      <Text fontWeight="medium">{tank.name}</Text>
                    </Td>

                    {/* Capacity */}
                    <Td textAlign="center">{tank.capacity}</Td>

                    {/* Connected To */}
                    <Td textAlign="center">
                      <Flex direction="column" align="center">
                        {tank.connected_to.map((item, i) => (
                          <Text key={i}>{item}</Text>
                        ))}
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box p={{ base: 4, md: 6 }} bg="gray.50" minH="100vh" mt="20px">
        {/* Confirmation box */}
        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Confirm Publish
              </AlertDialogHeader>

              <AlertDialogBody>
                Are you certain you want to trigger the command?
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={handleCancel}>
                  Cancel
                </Button>
                <Button colorScheme="blue" onClick={handleConfirm} ml={3}>
                  Okay
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        {/* Confirmation box ends */}

        {/* Header */}
        <Flex
          direction={{ base: 'row', md: 'row', lg: 'row' }}
          align="center"
          // justify="space-between"
          mb={{ base: 2, md: 2, lg: 4 }}
          gap={{ base: 2, md: 2, lg: 4 }}
        >
          <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">
            Overview
          </Text>
          <IconButton
            aria-label="Refresh"
            onClick={handleRefresh}
            icon={
              loading ? (
                <Spinner
                  thickness="3px"
                  speed="0.6s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="sm"
                />
              ) : (
                <RepeatIcon boxSize={5} />
              )
            }
            isRound
            bg="white"
            _hover={{ bg: 'gray.100' }}
            size="md"
            disabled={loading}
          />
          {userRole === 'admin' && (
            <Select
              placeholder="Select Company..."
              size="md"
              flex="1"
              maxW="300px"
              onChange={(e) => {
                selectedCompany.current = e.target.value;
                fetchOverviewData();
                fetchPermissibleLimits();
              }}
            >
              {/* Dynamic rendering of options */}
              {companyData.map((item) => (
                <option key={item.productId} value={item._id}>
                  {item.name}
                </option>
              ))}
            </Select>
          )}
        </Flex>

        {/* Top Status Section */}
        <Flex
          direction={{ base: 'column', md: 'column', lg: 'row' }} // stack on small, side-by-side on large
          gap={6}
          mb={6}
        >
          {/* 🌊 Left Panel */}
          {overViewData.length > 0 && (
            <Flex
              bg="white"
              p={4}
              rounded="2xl"
              shadow="sm"
              direction="column"
              align="center"
              flex={{ base: '1', lg: '1' }} // equal flex share on large
              w={{ base: '100%', lg: '50%' }} // 50% width on large
            >
              <Flex gap={4} wrap="nowrap" w="100%" overflowX="auto">
                {overViewData.map((device, i) => {
                  const isPumpOn = device.system.pump_status === 'on';
                  const status = device.status === 'online';
                  const IconComponent =
                    isPumpOn && status
                      ? BorewellIconPumpOn
                      : BorewellIconPumpOff;
                  const shouldBlink = isPumpOn && status;

                  return (
                    <Flex
                      key={i}
                      direction="column"
                      align="center"
                      justify="space-between"
                      border="2px solid"
                      borderColor="blackAlpha.50"
                      rounded="2xl"
                      p={3}
                      w="135px"
                      h="180px"
                      flexShrink={0}
                    >
                      <Box
                        w="100px"
                        h="100px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mb={2}
                        position="relative"
                      >
                        <IconComponent
                          style={{ width: '90px', height: '90px' }}
                        />
                        {shouldBlink && <Box {...blinkingOverlayProps} />}
                      </Box>

                      <Text
                        fontSize="md"
                        fontWeight="bold"
                        textAlign="center"
                        whiteSpace="pre-line"
                        noOfLines={2}
                      >
                        {device.borewellName}
                      </Text>
                    </Flex>
                  );
                })}
              </Flex>

              <Progress
                value={30}
                size="sm"
                rounded="full"
                w="95%"
                mt={4}
                sx={{
                  '& > div': {
                    background: 'rgba(0, 106, 184, 1)',
                  },
                }}
              />
            </Flex>
          )}

          {/* 💧 Right Panel */}
          {limitPerDay && (
            <Flex
              bg="white"
              p={4}
              rounded="2xl"
              shadow="sm"
              gap={4}
              justify="space-between"
              alignItems="stretch"
              direction={{ base: 'column', md: 'row', lg: 'row' }}
              flex={{ base: '1', lg: '1' }} // equal flex share
              w={{ base: '100%', lg: '50%' }} // 50% width on large
            >
              {/* Column 1: GW Abstraction */}
              {/* <Box
                flex="1"
                minW="280px"
                p={4}
                rounded="xl"
                border="2px solid"
                borderColor="blackAlpha.50"
              >
                <Text
                  fontSize="xl"
                  fontWeight="semibold"
                  color="rgba(0, 106, 184, 1)"
                  mb={4}
                  textAlign="center"
                >
                  GW Abstraction
                </Text>

                <Box mb={6}>
                  <Flex justify="space-between" mb={1} fontSize="md">
                    <Text fontWeight="bold" textDecoration="underline">
                      Actual Withdrawal
                    </Text>
                    <Text fontWeight="bold" textDecoration="underline">
                      Permitted
                    </Text>
                  </Flex>
                  <Flex justify="space-between" mb={1}>
                    <Text fontSize="md">
                      <Text
                        as="span"
                        fontWeight="semibold"
                        color="rgba(0, 106, 184, 1)"
                      >
                        {plantDailyCons}m³
                      </Text>
                    </Text>
                    <Text fontSize="md" color="green.500" fontWeight="medium">
                      {limitPerDay}m³/Day
                    </Text>
                  </Flex>
                  <Progress
                    value={Math.max(0, dailyProgressValue)}
                    size="sm"
                    sx={{
                      '& > div': { background: 'rgba(0, 106, 184, 1)' },
                      bg: 'gray.200',
                    }}
                    borderRadius="md"
                    w="100%"
                  />
                </Box>

                <Box>
                  <Flex justify="space-between" mb={2}>
                    <Text fontSize="md">
                      <Text
                        as="span"
                        fontWeight="semibold"
                        color="rgba(0, 106, 184, 1)"
                      >
                        {plantYearlyCons}m³
                      </Text>
                    </Text>
                    <Text fontSize="md" color="green.500" fontWeight="medium">
                      {limitPerYear}m³/Year
                    </Text>
                  </Flex>
                  <Progress
                    value={Math.max(0, yearlyProgressValue)}
                    size="sm"
                    sx={{
                      '& > div': { background: 'rgba(0, 106, 184, 1)' },
                      bg: 'gray.200',
                    }}
                    borderRadius="md"
                    w="100%"
                  />
                </Box>
              </Box> */}

              {/* Column 2: Overall Tank Capacity */}
              <Box
                flex="0 0 150px"
                textAlign="center"
                p={4}
                rounded="xl"
                border="2px solid"
                borderColor="blackAlpha.50"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                onClick={() => {
                  tanksOverview();
                  tankOverViewData && setisTankModalOpen(true);
                }}
              >
                <Text
                  fontSize="xl"
                  fontWeight="semibold"
                  color="rgba(0, 106, 184, 1)"
                  mb={4}
                >
                  {/* Overall Tank Capacity */}
                  Overall Tank Fill Level
                </Text>

                <Box
                  position="relative"
                  display="inline-block"
                  w="120px"
                  h="120px"
                  mx="auto"
                >
                  <TankLevelIcon style={{ width: '120px', height: '120px' }} />
                  <Text
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                    color="rgba(17, 128, 211, 1)"
                  >
                    {WaterTankLevel.toFixed(0)}%
                  </Text>
                </Box>
              </Box>
            </Flex>
          )}
        </Flex>

        {/* Borewell Cards Inlined */}
        <Grid
          templateColumns={{
            base: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          }}
          gap={2}
          bg="gray.50"
          sx={{
            '@media screen and (min-width: 1024px) and (max-width: 1366px)': {
              gridTemplateColumns: 'repeat(2, 1fr)', // override lg behavior
            },
            '@media screen and (min-width: 1800px) and (max-width:2499px)': {
              gridTemplateColumns: 'repeat(4, 1fr)',
            },
            '@media screen and (min-width: 2500px)': {
              gridTemplateColumns: 'repeat(5, 1fr)',
            },
          }}
        >
          {overViewData.map((item, index) => {
            const userRole = localStorage.getItem('role');

            // 🔵 Access from API
            // const monitor = item.devicesAccess?.[0]?.monitor;
            const control = item.devicesAccess?.[0]?.control;

            // 🔵 USER ACCESS RULES
            const canControl = userRole !== 'user' || control === true;

            const canRemote = userRole !== 'user' || control === true;

            // 🔵 PUMP OPERATION RULES
            const disablePumpBySystem =
              (item.system.operation_mode === 'auto' &&
                item.system.remote_operations === 'off') ||
              item.system.operation_mode === 'manual' ||
              item.system.pump_health === 'fault' ||
              item.status === 'offline';

            const disableRemoteBySystem =
              item.system.operation_mode === 'manual' ||
              item.status === 'offline';

            // 🔵 FINAL COMBINED CONDITIONS
            // const disablePump = !canControl || disablePumpBySystem;
            // const disableRemote = !canRemote || disableRemoteBySystem;
            const disableRemote = true;
            const disablePump = true;

            return (
              <Box
                key={index}
                bg="white"
                rounded="2xl"
                shadow="xl"
                p={8}
                border="1px solid"
                borderColor="gray.100"
                width="400px"
              >
                {/* Header */}
                <Flex justify="space-between" align="flex-start">
                  <VStack align="flex-start" spacing={0}>
                    <Text fontWeight="bold" fontSize="lg" color="gray.800">
                      {item.borewellName}
                    </Text>
                  </VStack>

                  <VStack align="center" spacing={0} mt={-4}>
                    {item.status === 'online' ? (
                      <ConnectedIcon
                        style={{ height: '25px', width: '25px' }}
                      />
                    ) : (
                      <DisconnectedIcon
                        style={{ height: '30px', width: '30px' }}
                      />
                    )}

                    <Text fontSize="sm" fontWeight="semibold" color="gray.500">
                      {item.status}
                    </Text>

                    <Text
                      fontSize="xs"
                      fontWeight="medium"
                      color="rgba(0,106,184,1)"
                    >
                      {item.system.remote_operations === 'on'
                        ? 'remote'
                        : item.system.operation_mode}
                    </Text>
                  </VStack>
                </Flex>

                {/* Pump Toggle */}
                <Flex justify="space-between" align="flex-start" mt={3}>
                  <Flex align="center" direction="column">
                    <Text fontSize="sm" fontWeight="bold" color="gray.500">
                      {item.productId}
                    </Text>
                    <Box mt={2}>
                      {isProcessing && selectedPID === item.productId ? (
                        <Image
                          src={PumpProcessing}
                          objectFit="fill"
                          rounded="3xl"
                          height="25px"
                          width="35px"
                          shadow="md"
                          bg="orange"
                        />
                      ) : (
                        <Image
                          src={
                            item.system.pump_status === 'on' ? OnIcon : OffIcon
                          }
                          objectFit="fill"
                          rounded="full"
                          height="25px"
                          width="auto"
                          shadow="md"
                          cursor={disablePump ? 'not-allowed' : 'pointer'}
                          opacity={disablePump ? 0.5 : 1}
                          onClick={() => {
                            if (disablePump) return;
                            setSelectedPID(item.productId);
                            handlePumpToggle(
                              item.system.pump_status,
                              item.productId,
                            );
                          }}
                        />
                      )}
                    </Box>
                  </Flex>

                  {/* Remote Toggle */}
                  <VStack flexShrink={0} align="center" spacing={0}>
                    <Text fontSize="sm" fontWeight="bold" color="gray.500">
                      Remote Operations
                    </Text>

                    <Box
                      onClick={() => {
                        if (disableRemote) return;
                        setSelectedPID(item.productId);
                        handleRemoteToggle(
                          item.system.remote_operations,
                          item.productId,
                        );
                      }}
                      sx={{
                        cursor: disableRemote ? 'not-allowed' : 'pointer',
                        opacity: disableRemote ? 0.5 : 1,
                      }}
                    >
                      {item.system.remote_operations === 'on' ? (
                        <RemoteButtonOn
                          style={{ height: '40px', width: '52px' }}
                        />
                      ) : (
                        <RemoteButtonOff
                          style={{ height: '40px', width: '52px' }}
                        />
                      )}
                    </Box>
                  </VStack>

                  <VStack flexShrink={0} align="center" spacing={0}>
                    <Text fontSize="sm" fontWeight="bold" color="gray.500">
                      Valve
                    </Text>

                    <Text
                      mt={2}
                      fontSize="md"
                      fontWeight="bold"
                      color="gray.500"
                    >
                      {item.system.valve_open === 'off' &&
                      item.system.valve_close === 'off'
                        ? 'Moving'
                        : item.system.valve_open === 'on' &&
                            item.system.valve_close === 'off'
                          ? 'Open'
                          : item.system.valve_open === 'off' &&
                              item.system.valve_close === 'on'
                            ? 'Closed'
                            : item.system.valve_open === 'on' &&
                                item.system.valve_close === 'on'
                              ? 'Fault'
                              : 'NA'}
                    </Text>
                  </VStack>
                </Flex>

                {/* Main Details */}
                <Grid templateColumns="repeat(3, 1fr)" gap={4} mt={3}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      Flow Rate
                    </Text>
                    <Text fontWeight="medium" fontSize="xl" color="gray.800">
                      {item.flowmeter_sensor.flowrate !== '-'
                        ? `${parseFloat(item.flowmeter_sensor.flowrate).toFixed(
                            1,
                          )}m³/hr`
                        : '-'}
                    </Text>
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      Totalizer
                    </Text>
                    <Text fontWeight="medium" fontSize="xl" color="gray.800">
                      {item.flowmeter_sensor.totalizer !== '-'
                        ? `${parseFloat(
                            item.flowmeter_sensor.totalizer,
                          ).toFixed(1)}m³`
                        : '-'}
                    </Text>
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    marginTop="-10px"
                  >
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      Valve
                    </Text>
                    <Text fontWeight="medium" fontSize="sm" color="gray.800">
                      {/* {item.dailyConsumption
                        ? `${item.dailyConsumption}m³`
                        : '-'} */}
                      Not connected
                    </Text>
                  </Box>
                </Grid>

                {/* Automation + Tank Level */}
                <Grid
                  templateColumns="1fr auto 1fr"
                  gap={2}
                  mt={5}
                  alignItems="center"
                >
                  <VStack align="center" spacing={2}>
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      Automation:{' '}
                      <Text as="span" fontWeight="bold" color="gray.800">
                        {/* {item.iotAuto.automation} */}
                        Disabled
                      </Text>
                    </Text>

                    <Text
                      fontSize="sm"
                      fontWeight="medium"
                      color="gray.500"
                      paddingRight="5px"
                    >
                      Schedule:{' '}
                      <Text as="span" fontWeight="bold" color="gray.800">
                        {/* {item.schedule} */}
                        Disabled
                      </Text>
                    </Text>
                  </VStack>

                  <Image
                    src={BorewellImage}
                    boxSize="120px"
                    objectFit="cover"
                    rounded="full"
                    shadow="md"
                  />

                  <VStack align="center" spacing={0}>
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      Tank Level
                    </Text>
                    <Text fontWeight="bold" color="gray.800">
                      {item.tank_sensor.water_level !== '-'
                        ? `${parseFloat(item.tank_sensor.water_level).toFixed(
                            1,
                          )}%`
                        : '-'}
                    </Text>

                    <Text
                      fontSize="sm"
                      fontWeight="medium"
                      color="gray.500"
                      marginTop="4px"
                    >
                      System Health
                    </Text>
                    <Text
                      fontWeight="medium"
                      fontSize="md"
                      color={
                        item.system.pump_health === 'nofault'
                          ? 'gray.800'
                          : 'red.500'
                      }
                    >
                      {item.system.pump_health === 'nofault'
                        ? 'No Fault'
                        : 'Fault'}
                    </Text>
                  </VStack>
                </Grid>

                <Text
                  fontSize="xs"
                  fontWeight="medium"
                  color="gray.800"
                  mt={4}
                  textAlign="center"
                >
                  Last Updated - {formatForDateTimeLocal(item.updatedAt)}
                </Text>
              </Box>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}
